document.addEventListener('change',event=>{if(event.target.id!=='NightVariant')return;document.querySelectorAll('[data-plans]').forEach(group=>{const active=group.dataset.plans===event.target.value;group.hidden=!active;group.disabled=!active;});});
(() => {
  function publish(name, data) {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy?.analyticsProcessingAllowed?.()) return;
    const analytics = window.Shopify?.analytics;
    if (typeof analytics?.publish !== 'function') return;
    try { analytics.publish('anavitam:' + name, data); } catch (_) {}
  }
  function pageView() {
    const editorial = document.querySelector('.editorial');
    const product = document.querySelector('.pdp');
    const home = document.querySelector('.hero:not(.pdp)');
    if (editorial || product || home) publish('funnel_view', { page_type: editorial ? 'editorial' : product ? 'night' : 'home' });
  }
  if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) pageView(); });
  document.addEventListener('visitorConsentCollected', pageView);
  document.addEventListener('click', event => {
    const link = event.target.closest('a');
    if (!link) return;
    const href = link.getAttribute('href');
    if (href === '/pages/anavitam-night') publish('night_cta_clicked', { placement: link.closest('.editorial') ? 'editorial' : link.closest('.nav') ? 'navigation' : 'content' });
    if (href === '#offers') publish('offers_cta_clicked', { placement: 'sticky' });
  });
  document.querySelectorAll('details').forEach((details, index) => details.addEventListener('toggle', () => { if (details.open) publish('faq_opened', { position: index + 1 }); }));
})();
